module.exports = __webpack_public_path__ + "img/move24.3c113adb.jpg";